import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  Tooltip,
  Autocomplete,
  ListItemText,
  Typography,
  Chip,
  Card,
} from "@mui/material";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledButton,
  OutlinedIconFab,
  theme,
  StyledCheckbox,
  StyledTableContainer,
} from "../StyledComponents";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import {
  medicineDurationTypesOptions,
  // medicineFrequencyOptions,
  medicineInstructionOptions,
} from "../initialData/initialData";
import Icon from "../Utils/Icons";
import { MedicationsTable } from "./MedicationsTable";
const Medications = ({
  activeSection,
  handleCrossButtonClick,
  data,
  setData,
  reasonsOptions,
  routeAutoData,
  initialObservationData,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [filteredFrequencyOptions, setFilteredFrequencyOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalled, setDebounceFunctionCalled] = useState(false);
  const [
    debounceFunctionCalledForFrequency,
    setDebounceFunctionCalledForFrequency,
  ] = useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [isFocused, setIsFocused] = useState(false);
  const [listeningOn, setListeningOn] = useState(false);
  console.log("filteredOptions", filteredOptions);
  const [newMedicine, setNewMedicine] = useState({
    id: null,
    term: "",
    selectedAdministration: null,
    reasons: [],
    frequency: [],
    duration: "",
    durationType: "Days",
    instructions: "",
    medicineNote: "",
  });
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const [frequencySelectedOrAdded, setFrequencySelectedOrAdded] =
    useState(false);
  const [medicineName, setMedicineName] = useState("");
  const [frequencyName, setFrequencyName] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [medicines, setMedicines] = useState(data);
  const [medicineFrequencyOptions, setMedicineFrequencyOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({
    id: null,
    term: "",
    selectedAdministration: null,
    reasons: "",
    frequency: "",
    duration: "",
    instructions: "",
    medicineNote: "",
  });
  const [drugType, setDrugType] = useState({
    branded: true,
    generic: true,
  });
  const [customFreqInput, setCustomFreqInput] = useState("");
  const [selectedSnomedCode, setSelectedSnomedCode] = useState(null);
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);
  const [mouseDownOnFrequencyOption, setMouseDownOnFrequencyOption] =
    useState(false);

  const lastFetchedMedicineType = useRef(null); // to prevent repeated calls
  const debounceTimeout = useRef(null); // useRef to persist timeout
  const skipEffectForMedicine = useRef(false);
  const skipEffectForFrequency = useRef(false);
  const medicineChosen = useRef(false);
  const frequencyChosen = useRef(false);
  console.log("initialObservationData", initialObservationData);
  const fallbackFrequencies = useRef(null); // to cache fallback frequencies
  const lastFetchedFrequenciesByType = useRef({}); // Cache per type

  useEffect(() => {
    setMedicines(data);
  }, [data]);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);
  const themeColour = "#21cdc0";

  const fetchMedicineFrequencies = async (medType) => {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_medicine_frequencies/`,
        { medicine_type: medType },
        { headers: headers }
      );

      if (response && response.data.status == "Success") {
        return response.data.frequencies;
      } else return [];
    } catch (err) {
      console.log(err);
    }
  };
  const lookupRelationshipAPI = async (sctCode) => {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}snomed/relationship_lookup/`,
        {
          concept_id: sctCode,
          relation: "has manufactured dose form",
          // relation: "has presentation strength denominator unit",
          direction: "source",
        },
        { headers: headers }
      );

      if (response && response.data.status == "Success") {
        return response.data.data[0].preferredName;
      } else return null;
    } catch (err) {
      console.log(err);
    }
  };

  //Preload generic frequency options ONCE
  // useEffect(() => {
  //   const preloadFrequencies = async () => {
  //     const response = await fetchMedicineFrequencies(""); // no payload
  //     fallbackFrequencies.current = response; // store in ref
  //   };
  //   preloadFrequencies();
  // }, []);

  useEffect(() => {
    // alert(`DH ${activeHistorySection}`);
    if (activeSection) {
      let timerId;

      timerId = setTimeout(() => {
        setMedicineName(transcript);
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [transcript]);

  useEffect(() => {
    if (skipEffectForMedicine.current) {
      skipEffectForMedicine.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when medicineName changes

    let timerOut = setTimeout(() => {
      if (medicineName.trim() !== "") {
        debouncedFilterCall(medicineName.toLowerCase());
      }
    }, 1000);
    return () => clearInterval(timerOut);
  }, [medicineName]);

  useEffect(() => {
    if (skipEffectForFrequency.current) {
      skipEffectForFrequency.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when frequencyName changes

    let timerOut = setTimeout(() => {
      if (frequencyName.trim() !== "") {
        debouncedFilterCallForFrequency(frequencyName.toLowerCase());
      }
    }, 1000);
    return () => clearInterval(timerOut);
  }, [frequencyName]);

  const startListening = (key) => {
    // alert("MH SL");
    if (transcript) {
      resetTranscript();
    }
    // setActiveHistorySection("Family History");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
  };
  const debouncedFilterCall = async (name) => {
    console.log("Debounce function called");
    let semanticTagForMedicine =
      drugType.branded && drugType.generic
        ? "real clinical drug++clinical drug"
        : drugType.branded
        ? "real clinical drug"
        : drugType.generic
        ? "clinical drug"
        : "";
    const postBody = {
      term: name,
      state: "active",
      semantictag: semanticTagForMedicine,
      acceptability: "synonyms",
      returnlimit: "-1",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (medicineName.length > 2) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            // const filteredData = dataToProcess.map((medicineItem) => {
            //   return {
            //     term: medicineItem.term,
            //     id: medicineItem.conceptId,
            //   };
            // });
            const filteredData = dataToProcess.map((medicineItem) => {
              let modifiedTerm = medicineItem.term;

              if (medicineItem.conceptFsn.includes("(real clinical drug)")) {
                // Extract the first parentheses content (ingredient like paracetamol)
                const matches = medicineItem.conceptFsn.match(/\(([^)]+)\)/);
                if (matches && matches[1]) {
                  const ingredient = matches[1].trim();
                  modifiedTerm = `${medicineItem.term} (${ingredient})`;
                }
              }

              return {
                term: modifiedTerm,
                id: medicineItem.conceptId,
              };
            });

            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              if (medicineName.length > 2) {
                const response = await axios.post(
                  `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                  postBody,
                  { headers: headers }
                );
                if (response) {
                  console.log("Suggest Response", response);
                  if (
                    response.data.status === "Success" &&
                    response.data.data.length > 0
                  ) {
                    setSuggestApiCalled(true);
                    const dataToProcess =
                      response.data.data.length > 300
                        ? response.data.data.slice(0, 300)
                        : response.data.data;
                    setAutoCompleteData(dataToProcess);
                    setFilteredOptions(dataToProcess);
                    // setSelectedFromSuggestion(true);
                  } else {
                    // setSelectedFromSuggestion(true);

                    setAutoCompleteData([]);
                    setFilteredOptions([]);
                  }
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalled(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const debouncedFilterCallForFrequency = async (name) => {
    console.log("Debounce function called");
    let semanticTagForInvestigations = "qualifier value";
    const postBody = {
      term: name,
      state: "active",
      semantictag: semanticTagForInvestigations,
      acceptability: "synonyms",
      returnlimit: "-1",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (frequencyName.length > 1) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((item) => {
              return {
                term: item.term,
                id: item.conceptId,
              };
            });
            console.log("Filtered Medicine Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredFrequencyOptions(filteredData);
          } else {
            try {
              if (frequencyName.length > 2) {
                const response = await axios.post(
                  `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                  postBody,
                  { headers: headers }
                );
                if (response) {
                  console.log("Suggest Response", response);
                  if (
                    response.data.status === "Success" &&
                    response.data.data.length > 0
                  ) {
                    setSuggestApiCalled(true);
                    const dataToProcess =
                      response.data.data.length > 300
                        ? response.data.data.slice(0, 300)
                        : response.data.data;
                    setAutoCompleteData(dataToProcess);
                    setFilteredFrequencyOptions(dataToProcess);
                    // setSelectedFromSuggestion(true);
                  } else {
                    // setSelectedFromSuggestion(true);

                    setAutoCompleteData([]);
                    setFilteredFrequencyOptions([]);
                  }
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalledForFrequency(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };

  const validateFields = () => {
    const errors = {};

    // Validate Medicine Name
    if (!newMedicine.term && medicineName.length === 0) {
      errors.term = "Medicine Name is a mandatory field.";
    }

    // Validate Frequency
    const hasFrequencies =
      Array.isArray(newMedicine.frequency) && newMedicine.frequency.length > 0;
    const hasUnconfirmedFreq = customFreqInput.trim() !== "";

    if (!hasFrequencies && !hasUnconfirmedFreq) {
      errors.frequency = "Frequency is a mandatory field.";
    } else if (hasUnconfirmedFreq) {
      const alreadyExists = newMedicine.frequency.some(
        (f) => f.term.toLowerCase() === customFreqInput.trim().toLowerCase()
      );

      if (!alreadyExists) {
        errors.frequency = "Please press enter to add your custom frequency.";
      }
    }

    // Validate Duration
    // if (!newMedicine.duration) {
    //   errors.duration = "Duration is a mandatory field.";
    // } else
    if (newMedicine?.duration < 0) {
      errors.duration = "Duration must not be a negative number.";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleAdd = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    let newDetails,
      updatedFound = {},
      updatedSelectedOptiondetsils = {},
      foundData = false;

    if (!medicineChosen.current) {
      const postBody = {
        term: medicineName,
        state: "active",
        semantictag: "real clinical drug++clinical drug",
        acceptability: "synonyms",
        returnlimit: "-1",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: true,
      };

      try {
        if (medicineName.length > 2) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
            postBody,
            { headers: headers }
          );
          if (response) {
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              foundData = response.data.data.find(
                (d) => d.term === medicineName
              );
              console.log("Found Data", foundData);
              if (foundData) {
                updatedFound = {
                  ...foundData,
                  found: true,
                  id: foundData.conceptId,
                };
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: medicineName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: medicineName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: medicineName,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: medicineName,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }

            if (foundData) {
              console.log("updatedFound", updatedFound);
              newDetails = {
                ...newMedicine,
                term: updatedFound.term,
                id: updatedFound.id,
              };
            } else {
              console.log(
                "updatedSelectedOptiondetsils",
                updatedSelectedOptiondetsils
              );
              newDetails = {
                ...newMedicine,
                term: updatedSelectedOptiondetsils.term,
                id: updatedSelectedOptiondetsils.id,
              };
            }
          } else {
            newDetails = {
              ...newMedicine,
              term: medicineName,
              id: null,
            };
            // handleInputChange("condition", updatedSelectedOptiondetsils);
          }
        }
      } catch (err) {
        console.log(err);
        // toast.error(err);
        newDetails = {
          ...newMedicine,
          term: medicineName,
          id: null,
        };
      }
    } else {
      newDetails = { ...newMedicine };
    }

    console.log("New Diagnosis Added", newDetails);

    // Add the new term to the complaints list
    let updatedDetails = [...medicines, newDetails];
    console.log("Diagnosis Updated Details", updatedDetails);
    setMedicines(updatedDetails);
    setNewMedicine({
      id: null,
      term: "",
      selectedAdministration: null,
      reasons: [],
      frequency: [],
      duration: "",
      durationType: "Days",
      instructions: "",
      medicineNote: "",
    });
    setValidationErrors({}); // Clear errors after successful submission
    setDebounceFunctionCalled(false);
    setDebounceFunctionCalledForFrequency(false);
    setTermSelectedOrAdded(false);
    setFrequencySelectedOrAdded(false);
    setMedicineName("");
    setFrequencyName("");
    setData(updatedDetails);
    medicineChosen.current = false;
    setFilteredOptions([]);
    frequencyChosen.current = false;
    setFilteredFrequencyOptions([]);
    setCustomFreqInput("");
  };

  // Function to handle input changes
  // const handleInputChange = (field, value) => {
  //   console.log("Term and its value", field, value);
  //   let newDetails;
  //   if (field == "term") {
  //     setAutoCompleteData([]);
  //     setFilteredOptions([]);
  //     setTermSelectedOrAdded(true);
  //     newDetails = {
  //       ...newMedicine,
  //       [field]: value.term,
  //       id: value.id,
  //     };
  //   } else {
  //     newDetails = {
  //       ...newMedicine,
  //       [field]: value,
  //     };
  //   }

  //   setNewMedicine(newDetails);
  // };
  const handleInputChange = (field, value) => {
    let newDetails;

    if (field === "term") {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
      setSelectedSnomedCode(value.id);
      newDetails = {
        ...newMedicine,
        [field]: value.term,
        id: value.id,
      };
    } else if (field === "frequency") {
      setFilteredFrequencyOptions([]);
      setAutoCompleteData([]);
      setFrequencySelectedOrAdded(true);
      // newDetails = {
      //   ...newMedicine,
      //   [field]: value, // already sanitized in Autocomplete's onChange
      // };
      const alreadyExists = newMedicine.frequency.some(
        (item) => item.term.toLowerCase() === value.term.toLowerCase()
      );

      if (!alreadyExists) {
        newDetails = {
          ...newMedicine,
          frequency: [
            ...newMedicine.frequency,
            { term: value.term, id: value.id },
          ],
        };
      } else {
        newDetails = { ...newMedicine };
      }
    } else {
      newDetails = {
        ...newMedicine,
        [field]: value,
      };
    }

    setNewMedicine(newDetails);
  };

  // Function to handle row edit
  const handleEditRow = (index) => {
    setMedicineName(medicines[index].term);
    setNewMedicine({ ...medicines[index], term: "" });
    setEditingIndex(index);
    // handleDeleteRow(index); // Remove the row from the list temporarily
  };
  console.log("Editing Index", editingIndex);
  const handleUpdate = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    let newDetails,
      updatedFound = {},
      updatedSelectedOptiondetsils = {},
      foundData = false;

    if (!medicineChosen.current) {
      const postBody = {
        term: medicineName,
        state: "active",
        semantictag: "real clinical drug++clinical drug",
        acceptability: "synonyms",
        returnlimit: "-1",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: true,
      };

      try {
        if (medicineName.length > 2) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
            postBody,
            { headers: headers }
          );
          if (response) {
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              foundData = response.data.data.find(
                (d) => d.term === medicineName
              );
              console.log("Found Data", foundData);
              if (foundData) {
                updatedFound = {
                  ...foundData,
                  found: true,
                  id: foundData.conceptId,
                };
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: medicineName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: medicineName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: medicineName,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: medicineName,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }

            if (foundData) {
              console.log("updatedFound", updatedFound);
              newDetails = {
                ...newMedicine,
                term: updatedFound.term,
                id: updatedFound.id,
              };
            } else {
              console.log(
                "updatedSelectedOptiondetsils",
                updatedSelectedOptiondetsils
              );
              newDetails = {
                ...newMedicine,
                term: updatedSelectedOptiondetsils.term,
                id: updatedSelectedOptiondetsils.id,
              };
            }
          } else {
            newDetails = {
              ...newMedicine,
              term: medicineName,
              id: null,
            };
            // handleInputChange("condition", updatedSelectedOptiondetsils);
          }
        }
      } catch (err) {
        console.log(err);
        // toast.error(err);
        newDetails = {
          ...newMedicine,
          term: medicineName,
          id: null,
        };
      }
    } else {
      newDetails = { ...newMedicine };
    }

    newDetails = { ...newDetails, source: undefined };

    let updatedDetails = medicines.map((data, i) =>
      i == editingIndex ? newDetails : data
    );
    setMedicines(updatedDetails);
    setEditingIndex(null);
    setNewMedicine({
      id: null,
      term: "",
      selectedAdministration: null,
      reasons: [],
      frequency: [],
      duration: "",
      durationType: "Days",
      instructions: "",
      medicineNote: "",
    });
    setValidationErrors({}); // Clear errors after successful submission
    setDebounceFunctionCalled(false);
    setDebounceFunctionCalledForFrequency(false);
    setTermSelectedOrAdded(false);
    setFrequencySelectedOrAdded(false);
    setMedicineName("");
    setFrequencyName("");
    setData(updatedDetails);
    medicineChosen.current = false;
    setFilteredOptions([]);
    frequencyChosen.current = false;
    setFilteredFrequencyOptions([]);
    setCustomFreqInput("");
  };
  // Function to handle row delete
  const handleDeleteRow = (index) => {
    let updatedDetails = medicines.filter((_, i) => i !== index);
    setMedicines(updatedDetails);
    setData(updatedDetails);
  };
  const memoizedHandleCrossButtonClick = useCallback(
    (sectionName, suggestionName, type) => {
      handleCrossButtonClick(sectionName, suggestionName, type);
    },
    [handleCrossButtonClick]
  );
  const handleClearName = () => {
    setValidationErrors({});
    setMedicineName("");
    resetTranscript();
    setNewMedicine({
      ...newMedicine,
      term: "", // Use computed property name to set the field dynamically
    });
    setFilteredOptions([]);
    setAutoCompleteData([]);
    setDebounceFunctionCalled(false);
    setTermSelectedOrAdded(false);
    // setMedicineList([])
    setSelectedSnomedCode(null);
    lastFetchedMedicineType.current = null;
    setMedicineFrequencyOptions([]);
  };
  const handleClearFrequency = () => {
    setValidationErrors({});
    setFrequencyName("");
    resetTranscript();
    setNewMedicine({
      ...newMedicine,
      frequency: [], // Use computed property name to set the field dynamically
    });
    setFilteredFrequencyOptions([]);
    setAutoCompleteData([]);
    setDebounceFunctionCalledForFrequency(false);
    setFrequencySelectedOrAdded(false);
    // setMedicineList([])
  };
  const handleAddOption = async (term) => {
    if (term.trim().length == 0) {
      const errors = {};
      errors.term = "You can't add an empty string";
      setValidationErrors(errors);
      return;
    }
    const postBody = {
      term: term,
      state: "active",
      semantictag: "real clinical drug++clinical drug",
      acceptability: "synonyms",
      returnlimit: "-1",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (medicineName.length > 2) {
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
          postBody,
          { headers: headers }
        );
        if (response) {
          let updatedFound = {},
            updatedSelectedOptiondetsils = {},
            foundData = false;
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            foundData = response.data.data.find((d) => d.term === term);
            console.log("Found Data", foundData);
            if (foundData) {
              updatedFound = {
                ...foundData,
                found: true,
                id: foundData.conceptId,
              };
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: term,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: term,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }
          } else {
            updatedSelectedOptiondetsils = {
              hierarchy: null,
              isPreferredTerm: null,
              conceptState: null,
              conceptFsn: term,
              definitionStatus: null,
              conceptId: null,
              languageCode: "en",
              typeId: null,
              term: term,
              caseSignificanceId: "CASE_INSENSITIVE",
              id: null,
              effectiveTime: null,
              activeStatus: null,
              moduleId: null,
            };
          }

          setAutoCompleteData([]);
          setFilteredOptions([]);
          setSuggestApiCalled(false);
          setDebounceFunctionCalled(true);
          if (foundData) {
            handleInputChange("term", updatedFound);
          } else {
            handleInputChange("term", updatedSelectedOptiondetsils);
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const handleDrugType = (type) => {
    setDrugType((prevDrugType) => ({
      ...prevDrugType,
      [type]: !prevDrugType[type],
    }));
  };

  const handleConditionTyped = (value) => {
    setMedicineName(value);

    if (value.trim() === "") {
      // Medicine name was cleared (via backspace, delete, or otherwise)
      setSelectedSnomedCode(null);
      lastFetchedMedicineType.current = null;
      setMedicineFrequencyOptions([]);
    }

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  console.log("Medicines data", medicines);
  console.log("Reasons", reasonsOptions);
  return (
    <ThemeProvider theme={theme}>
      {/* {activeSection && (
        <Grid item xs={12}>
          <Suggestions
            sectionName={sectionName}
            suggestions={suggestions}
            activeSection={activeSection}
            aiSuggestionToggle={aiSuggestionToggle}
            ruleSuggestionToggle={ruleSuggestionToggle}
            handleCrossButtonClick={memoizedHandleCrossButtonClick}
            handleSuggestionClick={setMedicineName}
          />
        </Grid>
      )} */}
      {activeSection && (
        <>
          {Array.isArray(initialObservationData) &&
            initialObservationData.length > 0 && (
              <Card
                sx={{
                  borderRadius: "10px",
                  boxShadow: "0 4px 4px 0 #C7C7CC inset",
                  backgroundColor: "#FFF",
                }}
              >
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Grid item xs={12} sm={11}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: "1rem",
                        mt: 2,
                        mb: 1,
                      }}
                      component="div"
                    >
                      Initial Observation
                    </Typography>

                    <TableContainer
                      component={Paper}
                      sx={{ border: `1px solid ${themeColour}`, mb: 2 }}
                    >
                      <Table>
                        <TableHead>
                          <StyledTableRowHistory>
                            <StyledTableCellHistory bgColor={themeColour}>
                              Panel
                            </StyledTableCellHistory>
                            <StyledTableCellHistory bgColor={themeColour}>
                              Test Name
                            </StyledTableCellHistory>
                            <StyledTableCellHistory bgColor={themeColour}>
                              Value
                            </StyledTableCellHistory>
                            <StyledTableCellHistory bgColor={themeColour}>
                              Unit
                            </StyledTableCellHistory>
                            <StyledTableCellHistory bgColor={themeColour}>
                              LOINC
                            </StyledTableCellHistory>
                          </StyledTableRowHistory>
                        </TableHead>
                        <TableBody>
                          {initialObservationData.map((panel, panelIndex) =>
                            panel.tests.map((test, testIndex) => (
                              <StyledTableRowHistory
                                key={`${panelIndex}_${testIndex}`}
                              >
                                <StyledTableCellHistory>
                                  {testIndex === 0 ? panel.panel_name : ""}
                                </StyledTableCellHistory>
                                <StyledTableCellHistory>
                                  {test.test}
                                </StyledTableCellHistory>
                                <StyledTableCellHistory>
                                  {test.value || "-"}
                                </StyledTableCellHistory>
                                <StyledTableCellHistory>
                                  {test.unit || "-"}
                                </StyledTableCellHistory>
                                <StyledTableCellHistory>
                                  {test.code || "-"}
                                </StyledTableCellHistory>
                              </StyledTableRowHistory>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </div>
              </Card>
            )}
          <Card
            sx={{
              borderRadius: "10px",
              boxShadow: "0 4px 4px 0 #C7C7CC inset",
              backgroundColor: "#FFF",
              backgroundImage: "url(/newImages/medicationsBackground.svg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Grid item xs={12} sm={12} md={12} sx={{ paddingTop: 0 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  marginTop: 0,
                  padding: "10px",
                  paddingTop: 0,
                }}
              >
                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={{ xs: "center", sm: "flex-end" }}
                  sx={{ display: "flex", flexDirection: "row", paddingTop: 0 }}
                >
                  <MenuItem
                    key="generic"
                    onClick={() => handleDrugType("generic")}
                  >
                    <StyledCheckbox checked={drugType.generic} />
                    <ListItemText primary="Generic" />
                  </MenuItem>
                  <MenuItem
                    key="branded"
                    onClick={() => handleDrugType("branded")}
                  >
                    <StyledCheckbox checked={drugType.branded} />
                    <ListItemText primary="Branded" />
                  </MenuItem>
                </Grid>
                <Grid item xs={12} sm={7} md={6}>
                  <StyledTextField
                    value={
                      // newMedicine.term !== "" ? newMedicine.term :
                      medicineName
                    }
                    onChange={(e) => {
                      // if (!newMedicine.term) {
                      //   setMedicineName(e.target.value);
                      // }
                      handleConditionTyped(e.target.value);
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        const shouldClear = !mouseDownOnOption;

                        if (shouldClear) {
                          // setIsFocused(false);
                          setFilteredOptions([]);
                          setDebounceFunctionCalled(false);
                          setTermSelectedOrAdded(false);
                        }

                        setMouseDownOnOption(false);
                      }, 100);
                    }}
                    onFocus={() => {
                      // setIsFocused(true);
                      if (medicineName.trim() !== "") {
                        debouncedFilterCall(medicineName.toLowerCase()); // re-trigger filtering
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div style={{ marginRight: "5px" }}>
                            <Tooltip title="Clear">
                              <OutlinedIconFab
                                size="small"
                                variant="contained"
                                onClick={handleClearName}
                              >
                                <Icon name="clearTextField" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>
                          {/* {!termSelectedOrAdded && (
                        <Tooltip title="Add" style={{ marginRight: "5px" }}>
                          <OutlinedIconFab
                            size="small"
                            variant="contained"
                            onClick={handleAddOption}
                          >
                            <AddIcon />
                          </OutlinedIconFab>
                        </Tooltip>
                      )} */}
                          <>
                            {isAiEnabled &&
                              (listeningOn === false ? (
                                <Tooltip title="Start Listening">
                                  <OutlinedIconFab
                                    // onClick={startListening}
                                    onClick={() => {
                                      startRecording();
                                      setListeningOn(true);
                                    }}
                                    variant="contained"
                                    // color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micNotInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Stop Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      // SpeechRecognition.stopListening();
                                      stopRecording("Medications");
                                      setListeningOn(false);
                                    }}
                                    variant="outlined"
                                    color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ))}
                          </>
                        </div>
                      ),
                    }}
                    label="Medicine Name"
                    fullWidth
                    error={!!validationErrors.term} // Highlight field in red if there's an error
                    helperText={validationErrors.term} // Show error message
                  />
                  {filteredOptions.length > 0 ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "200px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      {/* Display filtered medicines */}
                      {suggestApiCalled && (
                        <div style={{ color: "red" }}>
                          No Exact Matches found ! You can search for the
                          following Suggestions.
                        </div>
                      )}

                      <>
                        {filteredOptions.map((op) => (
                          <div key={op}>
                            {
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {op.added ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <StyledButton
                                      color="success"
                                      sx={{
                                        textAlign: "left",
                                        justifyContent: "flex-start",
                                        width: "100%",
                                      }}
                                    >
                                      {op.term}
                                    </StyledButton>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        flexDirection: "row",
                                        color: "green",
                                        fontStyle: "bold",
                                      }}
                                    >
                                      <span>&#10003;</span>
                                      <span>(Added)</span>
                                    </div>
                                  </div>
                                ) : (
                                  <StyledButton
                                    color="grey"
                                    sx={{
                                      textAlign: "left",
                                      justifyContent: "flex-start",
                                      width: "100%",
                                    }}
                                    onClick={() => {
                                      skipEffectForMedicine.current = true; // prevent debounce call
                                      medicineChosen.current = true;
                                      setMedicineName(op.term);
                                      handleInputChange("term", op);
                                    }}
                                    onMouseDown={() =>
                                      setMouseDownOnOption(true)
                                    }
                                  >
                                    {op.term}
                                  </StyledButton>
                                )}
                              </div>
                            }
                          </div>
                        ))}
                      </>
                    </div>
                  ) : filteredOptions.length == 0 &&
                    debounceFunctionCalled &&
                    !termSelectedOrAdded ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "300px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      <div style={{ color: "red" }}>No Options Found!</div>
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={6} sm={5} md={6}>
                  <StyledTextField
                    label="Direction of Use"
                    placeholder="Select or type custom direction of use"
                    fullWidth
                    error={!!validationErrors.frequency}
                    helperText={validationErrors.frequency}
                    value={frequencyName}
                    onChange={(e) => {
                      setFrequencyName(e.target.value);
                      setCustomFreqInput(e.target.value);
                    }}
                    onBlur={() => {
                      setIsFocused(false);
                      setTimeout(() => {
                        const shouldClear = !mouseDownOnFrequencyOption;

                        if (shouldClear) {
                          // setIsFocused(false);
                          setFilteredFrequencyOptions([]);
                          setDebounceFunctionCalledForFrequency(false);
                          setTermSelectedOrAdded(false);
                        }

                        setMouseDownOnFrequencyOption(false);
                      }, 100);
                    }}
                    onFocus={() => {
                      setIsFocused(true);
                      if (frequencyName.trim() !== "") {
                        debouncedFilterCallForFrequency(
                          frequencyName.toLowerCase()
                        ); // re-trigger filtering
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && frequencyName.trim() !== "") {
                        e.preventDefault();
                        const inputTerm = frequencyName.trim();

                        const alreadyExists = newMedicine.frequency.some(
                          (f) =>
                            f.term.toLowerCase() === inputTerm.toLowerCase()
                        );

                        if (!alreadyExists) {
                          setNewMedicine((prev) => ({
                            ...prev,
                            frequency: [
                              ...prev.frequency,
                              { term: inputTerm, id: null },
                            ],
                          }));
                        }

                        setFrequencyName(""); // clear input
                      }
                    }}
                    // onFocus={() => setIsFocused(true)}
                    // onBlur={() => setIsFocused(false)}
                    InputLabelProps={{
                      shrink:
                        isFocused ||
                        frequencyName !== "" ||
                        newMedicine.frequency.length > 0,
                    }}
                    InputProps={{
                      startAdornment: (() => {
                        const limit = 3;
                        const visibleChips = newMedicine.frequency.slice(
                          0,
                          limit
                        );
                        const hiddenCount =
                          newMedicine.frequency.length - limit;

                        return (
                          <>
                            {visibleChips.map((freq, index) => (
                              <Chip
                                key={index}
                                label={freq.term}
                                onDelete={() => {
                                  const updated = [...newMedicine.frequency];
                                  updated.splice(index, 1);
                                  setNewMedicine((prev) => ({
                                    ...prev,
                                    frequency: updated,
                                  }));
                                }}
                                style={{ margin: "2px" }}
                              />
                            ))}
                            {hiddenCount > 0 && (
                              <Chip
                                label={`+${hiddenCount}`}
                                style={{
                                  margin: "2px",
                                  backgroundColor: "#e0e0e0",
                                }}
                              />
                            )}
                          </>
                        );
                      })(),
                      endAdornment: (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div style={{ marginRight: "5px" }}>
                            <Tooltip title="Clear">
                              <OutlinedIconFab
                                size="small"
                                variant="contained"
                                onClick={handleClearFrequency}
                              >
                                <Icon name="clearTextField" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>

                          <>
                            {/* {listeningOn === false ? (
                            <Tooltip title="Start Listening">
                              <OutlinedIconFab
                                onClick={startListening}
                                variant="contained"
                                color="defaultColor"
                                size="small"
                              >
                                <MicOffIcon />
                              </OutlinedIconFab>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Stop Listening">
                              <OutlinedIconFab
                                onClick={() => {
                                  SpeechRecognition.stopListening();
                                  setListeningOn(false);
                                }}
                                variant="outlined"
                                color="defaultColor"
                                size="small"
                              >
                                <KeyboardVoiceIcon />
                              </OutlinedIconFab>
                            </Tooltip>
                          )} */}
                          </>
                        </div>
                      ),
                    }}
                  />

                  {filteredFrequencyOptions.length > 0 ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "200px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      {/* Display filtered medicines */}
                      {suggestApiCalled && (
                        <div style={{ color: "red" }}>
                          No Exact Matches found ! You can search for the
                          following Suggestions.
                        </div>
                      )}

                      <>
                        {filteredFrequencyOptions.map((op) => (
                          <div key={op}>
                            {
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {newMedicine.frequency.some(
                                  (f) => f.term === op.term
                                ) ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <StyledButton
                                      color="success"
                                      sx={{
                                        textAlign: "left",
                                        justifyContent: "flex-start",
                                        width: "100%",
                                      }}
                                    >
                                      {op.term}
                                    </StyledButton>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        flexDirection: "row",
                                        color: "green",
                                        fontStyle: "bold",
                                      }}
                                    >
                                      <span>&#10003;</span>
                                      <span>(Added)</span>
                                    </div>
                                  </div>
                                ) : (
                                  <StyledButton
                                    color="grey"
                                    sx={{
                                      textAlign: "left",
                                      justifyContent: "flex-start",
                                      width: "100%",
                                    }}
                                    onClick={() => {
                                      skipEffectForFrequency.current = true; // prevent debounce call
                                      frequencyChosen.current = true;
                                      setFrequencyName("");
                                      handleInputChange("frequency", op);
                                      setCustomFreqInput("");
                                    }}
                                    onMouseDown={() =>
                                      setMouseDownOnFrequencyOption(true)
                                    }
                                  >
                                    {op.term}
                                  </StyledButton>
                                )}
                              </div>
                            }
                          </div>
                        ))}
                      </>
                    </div>
                  ) : filteredFrequencyOptions.length == 0 &&
                    debounceFunctionCalledForFrequency &&
                    !frequencySelectedOrAdded ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "300px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      <div style={{ color: "red" }}>No Options Found!</div>
                    </div>
                  ) : null}
                </Grid>
                {/* <Grid item xs={6} sm={5} md={6}>
                <Autocomplete
                  multiple
                  freeSolo
                  limitTags={3}
                  disableCloseOnSelect
                  clearOnBlur={false}
                  options={medicineFrequencyOptions}
                  value={newMedicine.frequency || []}
                  onFocus={async () => {
                    let snomedCodeToUse = selectedSnomedCode;

                    // CASE 1: No SNOMED selected, check for exact match
                    if (
                      !snomedCodeToUse &&
                      medicineName &&
                      filteredOptions.length > 0
                    ) {
                      const match = filteredOptions.find(
                        (opt) =>
                          opt.term.toLowerCase() === medicineName.toLowerCase()
                      );
                      console.log("match", match);
                      if (match && match.id) {
                        snomedCodeToUse = match.id;
                        setSelectedSnomedCode(match.id);
                      }
                    }

                    // CASE 2: We now either have SNOMED or not
                    if (snomedCodeToUse) {
                      const medicineType = await lookupRelationshipAPI(
                        snomedCodeToUse
                      );
                      console.log("medicineType", medicineType);
                      console.log(
                        "lastFetchedMedicineType.current",
                        lastFetchedMedicineType.current
                      );
                      // Prevent repeated API calls for same medicineType
                      if (
                        medicineType &&
                        medicineType !== lastFetchedMedicineType.current
                      ) {
                        lastFetchedMedicineType.current = medicineType;

                        //  use caching for medicineType frequencies
                        if (
                          lastFetchedFrequenciesByType.current[medicineType]
                        ) {
                          setMedicineFrequencyOptions(
                            lastFetchedFrequenciesByType.current[medicineType]
                          );
                        } else {
                          const freqs = await fetchMedicineFrequencies(
                            medicineType
                          );

                          if (freqs.length > 0) {
                            setMedicineFrequencyOptions(freqs);
                            lastFetchedFrequenciesByType.current[medicineType] =
                              freqs; // cache it
                          } else {
                            setMedicineFrequencyOptions(
                              fallbackFrequencies.current
                            );
                          }
                        }
                      } else if (medicineType) {
                        // Already fetched this medicineType

                        setMedicineFrequencyOptions(
                          lastFetchedFrequenciesByType.current[medicineType] ||
                            fallbackFrequencies.current ||
                            []
                        );
                      } else {
                        // No medicine type found, fallback

                        setMedicineFrequencyOptions(
                          fallbackFrequencies.current || []
                        );
                      }
                    } else if (
                      !snomedCodeToUse &&
                      medicineName.length === 0 &&
                      filteredOptions.length === 0
                    ) {
                      // no medicine name added
                      console.log("no snomed, no medicine name");
                      setMedicineFrequencyOptions([]);
                    } else {
                      // No SNOMED at all, fallback

                      setMedicineFrequencyOptions(
                        fallbackFrequencies.current || []
                      );
                    }
                  }}
                  onChange={(event, newValue) => {
                    const unique = [];
                    const seen = new Set();

                    for (let item of newValue) {
                      // If item is string (free text), convert to object with defaults
                      let obj =
                        typeof item === "string"
                          ? {
                              medicine_type: "Custom", // or "" or "Free Text"
                              frequency_code: item,
                              full_form: item,
                              description: item,
                            }
                          : item;

                      // Use frequency_code in lowercase as unique key
                      const key = obj.frequency_code.toLowerCase();

                      if (!seen.has(key)) {
                        seen.add(key);
                        unique.push(obj);
                      }
                    }

                    handleInputChange("frequency", unique);
                  }}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") return option;
                    return `${option.frequency_code} ${
                      option.medicine_type !== "Custom"
                        ? `(${option.full_form})`
                        : ""
                    }`;
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (
                      typeof option === "string" ||
                      typeof value === "string"
                    ) {
                      return option === value;
                    }
                    return option.frequency_code === value.frequency_code;
                  }}
                  filterOptions={(options, state) => {
                    const filtered = options.filter((opt) =>
                      `${opt.frequency_code} (${opt.full_form})`
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase())
                    );

                    // Add typed value as an option
                    if (
                      state.inputValue !== "" &&
                      !filtered.some((opt) => {
                        const label =
                          `${opt.frequency_code} (${opt.full_form})`.toLowerCase();
                        return label === state.inputValue.toLowerCase();
                      })
                    ) {
                      filtered.push(state.inputValue);
                      setCustomFreqInput(state.inputValue);
                    }

                    return filtered;
                  }}
                  renderInput={(params) => (
                    <StyledTextField
                      {...params}
                      label="Frequency"
                      placeholder="Select or type custom frequency"
                      fullWidth
                      error={!!validationErrors.frequency}
                      helperText={validationErrors.frequency}
                    />
                  )}
                />
              </Grid> */}
                {/* <Grid item xs={6} sm={2.5} md={3}>
                <Autocomplete
                  freeSolo
                  options={medicineInstructionOptions}
                  value={newMedicine.instructions}
                  onChange={(event, newValue) =>
                    handleInputChange("instructions", newValue)
                  } // Use newValue
                  onInputChange={(event, newInputValue) => {
                    // Handle free text input separately
                    handleInputChange("instructions", newInputValue);
                  }}
                  renderInput={(params) => (
                    <StyledTextField
                      {...params}
                      label="Instruction"
                      placeholder="Select or type custom instruction"
                      fullWidth
                      error={!!validationErrors.instructions} // Highlight field in red if there's an error
                      helperText={validationErrors.instructions} // Show error message
                    />
                  )}
                />
              </Grid> */}
                <Grid container item xs={7} sm={6} md={3} spacing={2}>
                  <Grid item xs={5} lg={4}>
                    <StyledTextField
                      type="number"
                      label="Duration"
                      variant="outlined"
                      value={newMedicine.duration}
                      size="small"
                      inputProps={{ min: 0 }}
                      onChange={(e) =>
                        handleInputChange("duration", e.target.value)
                      }
                      error={!!validationErrors.duration} // Highlight field in red if there's an error
                      helperText={validationErrors.duration} // Show error message
                    />
                  </Grid>
                  <Grid item xs={7} lg={8}>
                    <StyledTextField
                      fullWidth
                      label="Duration Type"
                      select
                      value={newMedicine?.durationType || "days"}
                      onChange={(e) =>
                        handleInputChange("durationType", e.target.value)
                      }
                    >
                      {medicineDurationTypesOptions.map((status, index) => (
                        <MenuItem
                          key={index}
                          value={status}
                          sx={{ fontSize: "12px" }}
                        >
                          {status}
                        </MenuItem>
                      ))}
                    </StyledTextField>
                  </Grid>
                </Grid>
                <Grid item xs={5} sm={6} md={2}>
                  <Autocomplete
                    options={routeAutoData} // Predefined options for selection
                    value={newMedicine.selectedAdministration} // Bind to the selected value
                    onChange={
                      (event, newValue) =>
                        handleInputChange("selectedAdministration", newValue) // Update state on selection change
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    } // Define equality check
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-listbox": {
                            fontSize: "12px", // sets option font size
                          },
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <StyledTextField
                        {...params}
                        label="Administration"
                        placeholder="Select administration method"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={5} md={3}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    options={reasonsOptions} // Predefined list of options
                    value={newMedicine.reasons} // Bind selected values
                    onChange={(event, newValue) => {
                      handleInputChange("reasons", newValue); // Store only the 'condition' values
                    }}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-listbox": {
                            fontSize: "12px", //sets option font size
                          },
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <StyledTextField {...params} label="Reasons" fullWidth />
                    )}
                  />
                </Grid>

                <Grid item xs={8} sm={5} md={3}>
                  <StyledTextField
                    fullWidth
                    label="Notes"
                    value={newMedicine.medicineNote}
                    onChange={(e) =>
                      handleInputChange("medicineNote", e.target.value)
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  md={1}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <StyledButton
                    onClick={editingIndex != null ? handleUpdate : handleAdd}
                    variant="contained"
                    sx={{
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                      width: "100%",
                    }}
                    bgColor="#0E3F66"
                  >
                    {editingIndex != null ? "Update" : "Add"}
                  </StyledButton>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </>
      )}
      {medicines && (
        <MedicationsTable
          data={medicines}
          activeSection={activeSection}
          handleEditRow={handleEditRow}
          handleDeleteRow={handleDeleteRow}
        />
      )}
    </ThemeProvider>
  );
};

export default Medications;
